// extracted by mini-css-extract-plugin
module.exports = {"HeaderTitle":"Header_HeaderTitle__2WbA4"};